<template>
  <div class="mb-5 pb-5 bg-white">
    <div class="py-3 px-3">
      <h2 class="text-weight-500 mb-1">キャンセルの注意点</h2>
      <ul class="rule-list">
        <li class="text-weight-500 text-red text-size-14 mb-2 caution">
          <FeatherIcon
            icon="alert-triangle"
            size="18"
            class="caution-icon"
          />同一事業所へ応募不可となる可能性があります
        </li>
        <li class="text-weight-500 text-red text-size-14 caution">
          <FeatherIcon
            icon="alert-triangle"
            size="18"
            class="caution-icon"
          />信用スコアが0ptになると一時的にお仕事へ応募不可となります
        </li>
      </ul>
    </div>
    <div class="py-2 px-3">
      <h2 class="text-weight-500">信用スコアのルール</h2>
      <p class="text-size-14 text-mild mt-1">
        キャンセルの場合は、事業所側に連絡したタイミングに応じて、信用スコアが減少します。
      </p>
    </div>

    <div class="py-2 px-3">
      <img
        src="@/assets/svg/credit_score_rules.svg"
        alt=""
        class="credit-score-rules-img"
      />
    </div>

    <div class="py-2 px-3">
      <dl class="rule-list">
        <dt class="text-weight-500 text-red">
          <FeatherIcon icon="alert-triangle" size="18" class="mr-2" />無断欠勤
        </dt>
        <dd class="rule-list-text text-mild">
          連絡なし欠勤：アカウントの一時利用停止
        </dd>

        <dt class="text-weight-500 text-yellow mt-2">
          <FeatherIcon icon="alert-triangle" size="18" class="mr-2" />遅刻
        </dt>
        <dd class="rule-list-text text-mild">
          自己都合の遅刻・早退：スコア-2点
        </dd>

        <dt class="text-weight-500 text-green mt-2">
          <FeatherIcon icon="battery-charging" size="18" class="mr-2" />復活制度
        </dt>
        <dd class="rule-list-text text-mild mb-0">
          1回の勤務：信用スコア+1点
        </dd>
      </dl>
    </div>

    <!-- 一時的にコメントアウト -->
    <!-- <section class="py-2 px-3">
      <h2 class="text-weight-500">前日確認</h2>
      <p class="text-size-14 text-mild mt-1">
        勤務の可否を確認するため、お仕事の前日にアプリを起動し、「勤務確定」をお願いします。
        <br />
        前日に「勤務確定」されない場合、お仕事がキャンセルされる可能性がございますので、ご注意ください。
      </p>
    </section> -->

    <slot />
  </div>
</template>

<script lang="ts">
import { APP_SERVICE_NAME_KANA } from "@/const/app";
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

@Component({
  components: {
    FeatherIcon
  }
})
export default class CancelPolicyContent extends Vue {
  get serviceNameKana() {
    return APP_SERVICE_NAME_KANA;
  }
}
</script>

<style lang="scss" scoped>
.line-height-14 {
  line-height: 14px;
}

.rule-list {
  padding: 16px;
  font-size: 14px;
  background-color: $primary-bg;
  border: 1px solid $yellow;
  border-radius: 4px;

  &-text {
    padding-left: 26px;
  }
}

.caution {
  position: relative;
  padding-left: 26px;
}

.caution-icon {
  position: absolute;
  top: 2px;
  left: 0;
}

.credit-score-rules-img {
  width: 100%;
}
</style>
